@let isLgAndUp = viewportSelectors.isLgAndUp | select: false;
@if (visibleOptionsExist | select) {
  <mx-expandable-card [expansionState]="expansionState" [lazyLoadContent]="false" class="mx-elevation-0" [class.mx-no-padding]="!isLgAndUp"
                      expansionPanelClasses="border-[0.0625rem] border-[--mx-card-border-color]"
                      (expansionStateChanged)="onExpansionStateChanged($event)">
    <div header class="w-full ps-4 lg:ps-0">
      <div class="flex flex-row justify-between items-center w-full py-0 lg:py-3">
        <span class="text-title-medium lg:text-headline-small">{{ cardTitle }}</span>

        <mx-expandable-card-toggle-button [state]="expansionState" [collapsedRotation]="-90" [expandedRotation]="0"/>
      </div>
    </div>

    <div class="px-2 lg:px-0">
      <px-catalog-filter-options [options]="visibleOptions | select:[]" (selectionChanged)="onSelectionChanged($event)"/>
    </div>

    @if (moreOptionsExist | select) {
      <mx-action-buttons>
        <mx-text-button startIcon="add" label="See All" (click)="onClickSeeAllButton()"/>
      </mx-action-buttons>
    }
  </mx-expandable-card>
}
